// Media paths and translation keys are explicit so IDs need not match filenames.
export const interviews = [
  { id: 'interview-1', productId: 'hi-cps', translationKey: 'successStories.interviews.1', video: '/videos/interview_1.mp4', poster: '/images/success-stories/interview_1.jpg' },
  { id: 'interview-2', productId: 'pg-solution', translationKey: 'successStories.interviews.2', video: '/videos/interview_2.mp4', poster: '/images/success-stories/interview_2.jpg' },
  { id: 'interview-3', productId: 'pg-solution', translationKey: 'successStories.interviews.3', video: '/videos/interview_3.mp4', poster: '/images/success-stories/interview_3.jpg' },
  { id: 'interview-4', productId: 'pg-solution', translationKey: 'successStories.interviews.4', video: '/videos/interview_4.mp4', poster: '/images/success-stories/interview_4.jpg' },
];

export function getStoryFilters(stories) {
  const counts = new Map();
  stories.forEach(({ productId }) => counts.set(productId, (counts.get(productId) || 0) + 1));
  return [{ id: 'all', count: stories.length }, ...Array.from(counts, ([id, count]) => ({ id, count }))];
}
